module.exports = __webpack_public_path__ + "img/offline.0abc1af3.png";